import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { combineLatest, delay } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { SvgIconDirective } from '@styleguide/svg-icon/svg-icon.directive';
import { IfModuleEnabledDirective } from '@customer-apps/enabled-modules/if-module-enabled.directive';
import { ModuleService } from '@customer-apps/enabled-modules/enabled-modules.service';

@Component({
  selector: 'kgr-tabbar',
  templateUrl: './tabbar.component.html',
  styleUrls: ['./tabbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLinkActive, RouterLink, SvgIconDirective, IfModuleEnabledDirective],
})
export class TabbarComponent {
  constructor(moduleService: ModuleService, cd: ChangeDetectorRef) {
    combineLatest([moduleService.isModuleEnabled$('Chat'), moduleService.isModuleEnabled$('offering')])
      .pipe(takeUntilDestroyed(), delay(0))
      .subscribe(() => {
        cd.markForCheck();
      });
  }
}
